import React, { useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';

const VerifieCompteClub = () => {
    const [showToast, setShowToast] = useState(false);
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        setShowToast(true);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);

        setTimeout(() => {
            navigate('/profile');
        }, 1000);
    };

    return (
        <>
            <a
                href="/details"
                onClick={handleClick}
                className="text-primary"
                style={{
                    color: "#157088",
                    textDecoration: "underline",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                vérifier votre compte
            </a>
            <FaCheckCircle style={{ marginLeft: "8px" }} />
            {/* Toast de confirmation */}
            <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}>
                <Toast isOpen={showToast}>
                    <ToastHeader icon="success">
                        Succès
                    </ToastHeader>
                    <ToastBody>Votre compte a bien été vérifié.</ToastBody>
                </Toast>
            </div>
        </>
    );
};

export default VerifieCompteClub;
